<template>
  <div>
    <div class="flex">
      <loading-indicator ></loading-indicator>
      <div class="offset-lg-1 col-11 text-center">
        <h3 class="intro-headline my-4">Authenticating...</h3>
      </div>
    </div>
  </div>
</template>

<script>
  import { LOGIN_AS_STUDENT, URL_LOGIN } from '@/store/actions/auth.actions';
  import LoadingIndicator from '@/component/LoadingIndicator';

  export default {
    name: 'Auth',

    components: {
      LoadingIndicator
    },

    created: function () {
      const hash = this.$route.params.hash;
      this.$store.dispatch(URL_LOGIN, { hash: hash })
        .then(() => this.$store.dispatch(LOGIN_AS_STUDENT))
        .then(() => this.$router.push('/student'))
        .catch(() => this.$router.push('/home'));
    },
  };
</script>

<style lang="scss" scoped>
  .intro-headline {
    @apply text-primary leading-tight;
    font-size: 44px;
  }
</style>
